<template>
    <div class="date-wrap">
        <div class="date-filter">
            <VueDatePicker ref="startDatePicker" v-model="startDate" input-class-name="dp-custom-input"
                :format-locale="zhCN" format="yyyy/M/dd" locale="zhCN" close-on-scroll :enable-time-picker="false"
                :placeholder="$t('选择日期')" :teleport-center="store.state.isMobile" :transitions="!store.state.isMobile">
                <template #input-icon>
                    <img class="input-slot-image" src="../../assets/img/icons/icon-date-filter.png" />
                </template>
                <template #action-buttons>
                    <p class="custom-select" @click="cancelSelectStartDate">{{ $t("取消") }}</p>
                    <p class="custom-select sure" @click="selectStartDate">{{ $t("确认") }}</p>
                </template>
            </VueDatePicker>
        </div>
        <div class="search">{{ $t("确定") }}</div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { zhCN } from 'date-fns/locale';

const store = useStore();
const startDate = ref();
const endDate = ref();
const isFilterShow = ref(true);
const startDatePicker = ref();

function selectStartDate() {
    startDatePicker.value.selectDate();
}


function cancelSelectStartDate() {
    startDatePicker.value.closeMenu();
}



</script>

<style scoped src="./globalDate.css"></style>
